import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import VueSession from 'vue-session'
import { getTime, parseISO } from 'date-fns';

Vue.use(VueSession)
Vue.use(Vuex)

/*eslint-disable */
const qs = require("qs");
/*eslint-enable */

export default new Vuex.Store({
  state: Vue.prototype.$session.get('temp_state') || {
    timeZone: "Asia/Jakarta",
    captcha_key: process.env.VUE_APP_CAPCHA_KEY || '6LccYVIgAAAAAFOxujBG-QtWi2TPTZuYmVGjI4KP',
    data: {
      get: {
        using_sso: '0'
      },
      post: {
        interactive_content_id: null,
        interactive_page: 1,
        tracking_id: null,
        profiling_answer: {},
        is_finished: 0,
        is_submited: 0,
        score: 0,
        answer: {},
        additional: {},
        label: {},
        interactive_result_id: 0,
        user_agent: navigator.userAgent,
        ip_address: null,
        referrer: document.referrer ? document.referrer : window.location.href,
        action: 'tracking',
      },
      meta: {
        title: "Untitled",
        description: "",
        image: ""
      },
      isRunning: true,
      visitorId: (
        window.ahoy ? (window.ahoy.visitorId || 
          decodeURIComponent(document.cookie.split(';').find(v=>{ return v.match('ahoy_visitor=');})).trim().replace('ahoy_visitor=', '')
        ) : 
        decodeURIComponent(document.cookie.split(';').find(v=>{ return v.match('ahoy_visitor=');})).trim().replace('ahoy_visitor=', '')
      ),
      userLogin: null,
      afterLoginPage: 'profiling',
      afterLoginPageParams: {},
      profilingCDPFields: ['email', 'name', 'phone', 'age', 'yob', 'dob', 'gender'],
      triviaResult: null,
      QuestionResult: null,
    },
    leaderboard: {
      get:{},
    },
    axios: {
      baseURL: process.env.VUE_APP_NEWSHUB_URL,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
      }
    },
    isLoading: false,
    progressLoading: 0,
    isEmbed: false,
    isValidAnswer: false,
    isValidProfiling: false,
    isCombine: false,
    isValidCombine: false,
    token: process.env.VUE_APP_NEWSHUB_TOKEN,
    iframe_url: window.location.href,
    interval: null,
    sso_config: {
        enable: true,
        uid: null,
        endPoint: process.env.VUE_APP_NEWSHUB_SSO_URL,
        clientId: process.env.VUE_APP_NEWSHUB_SSO_CLIENT_ID,
        clientSecret: process.env.VUE_APP_NEWSHUB_SSO_CLIENT_SC
    },
    layouts: {
      flow: ['cover', 'intro', 'profiling', 'question', 'result'],
      display: {
        cover:{
          button:{
            text: "Mulai"
          }
        },
        intro:{
          button:{
            text: "Mulai"
          }
        }
      }
    }
  },
  getters: {
    axios: state => {
      return axios.create(state.axios);
    }
  },
  mutations: {
    set_post_profiling(state, values)
    {
      state.data.post.profiling_answer = values
    },
    set_post_answer(state, values)
    {
      state.data.post.answer = values
    },
    set_is_loading(state, status)
    {
      state.isLoading = status
    },
    set_is_valid_combine(state, status)
    {
      state.isValidCombine = status
    },
    set_isvalid_profiling(state, status)
    {
      state.isValidProfiling = status
    },
    set_isvalid_answer(state, status)
    {
      state.isValidAnswer = status
    },
    set_is_combine(state, status)
    {
      state.isCombine = status
      state.data.get.style = 'vertical'
    },
    clear_post_answer(state)
    {
      state.data.post.answer = {}
      state.isValidAnswer = false
    },
    finish_trivia(state)
    {
      state.data.post.is_finished = 1

      this.dispatch('api_post_ic');
    },
  },
  actions: {

    scheduleCheck({ state })
    {
        if( state.data.get?.schedule_start )
        {
            if( getTime(parseISO(state.data.get?.schedule_start)) > getTime(new Date()) )
            {
                state.data.isRunning = false;
            }
        }
        if( state.data.get?.schedule_end )
        {
            if( getTime(parseISO(state.data.get?.schedule_end)) < getTime(new Date()) )
            {
                state.data.isRunning = false;
            }
        }

        return state.data.isRunning;
    },

    async api_get_list({ getters, state }, params) {
      var data = await Promise.all([
              
        //GET NEWSHUB API
        getters.axios.get(
          "api/interactive-content/&page="+(params.page||1)+"&token=" + state.token +'&s=' + Math.random().toString(36).substring(7)
        ),

      ]).catch(error => {
        Vue.toasted.show(error, {type:'error'}).goAway(1500);
      });

      return data[0] ? params.callback(data[0].data) : params.callback(null)
    },

    async api_get_img({ getters, state }, params) {
      var data = await Promise.all([
              
        //GET NEWSHUB API
        getters.axios.post(
          "api/interactive-content/image_string&token=" + state.token +'&s=' + Math.random().toString(36).substring(7),
          {
            img: params.img
          }
        ),

      ]).catch(error => {
        Vue.toasted.show(error, {type:'error'}).goAway(1500);
      });

      return data[0] ? params.callback(data[0].data) : params.callback(null)
    },

    async api_get_ic({ getters, state }, interactiveId) {
      
      var data = [];

      if( state.data?.get && state.data?.get?.id == interactiveId )
      {
        data = [
          {
            data: state.data.get
          },
          {
            data: {ip:state.data.post.ip_address}
          },
        ];
      }
      else
      {
        if( window.ic_content && window.ip_address )
        {
          data = [
            window.ic_content,
            window.ip_address,
          ];
        }
        else
        {
            data = await Promise.all([
              
              //GET NEWSHUB API
              getters.axios.get(
                "api/interactive-content/" + interactiveId + "/&token=" + state.token +'&s=' + Math.random().toString(36).substring(7)
              ),

              //GET IP ADDRESS
              getters.axios.get("https://api.ipify.org?format=json")

            ]).catch(error => {
              Vue.toasted.show(error, {type:'error'}).goAway(1500);
            });
        }
      }

      if (data && data[0])
      {
        state.data.get = data[0].data
        state.data.post.interactive_content_id = data[0].data.id
        state.data.post.tracking_id = data[0].data.tracking_id
        state.data.post.interactive_page = 1
        state.data.post.is_finished = 0
        state.data.post.is_submited = 0

        //meta data
        state.data.meta.title = data[0].data.name
        state.data.meta.description = data[0].data.description
        state.data.meta.image = (data[0].data.cover_image ? data[0].data.cover_image.real : null) || 
                                (data[0].data.headline_image ? data[0].data.headline_image.real : null)
      }

      if( data && data[1] )  state.data.post.ip_address = data[1].data.ip

      //UTM
      var q ={};location.search.replace(/([^?&=]+)=([^&]+)/g,(_,k,v)=>q[k]=v);q;

      state.data.post.utm = {
            'utm_source': q.utm_source ? q.utm_source : '',
            'utm_medium': q.utm_medium ? q.utm_medium : '',
            'utm_campaign': q.utm_campaign ? q.utm_campaign : '',
            'utm_term': q.utm_term ? q.utm_term : '',
            'utm_content': q.utm_content ? q.utm_content : '',
        };

      return state.data
    },

    async api_get_lb({ getters, state }, leaderBoardID) {
      
      var data = await Promise.all([
              
        //GET NEWSHUB API
        getters.axios.get(
          "api/leaderboard/" + leaderBoardID + "/&token=" + state.token +'&s=' + Math.random().toString(36).substring(7)
        ),

        //GET IP ADDRESS
        getters.axios.get("https://api.ipify.org?format=json")

      ]).catch(error => {
        Vue.toasted.show(error, {type:'error'}).goAway(1500);
      });

      if (data && data[0])
      {
        state.leaderboard.get = data[0].data

        //meta data
        state.data.meta.title = data[0].data.name
        state.data.meta.description = data[0].data.description
      }

      //UTM
      var q ={};location.search.replace(/([^?&=]+)=([^&]+)/g,(_,k,v)=>q[k]=v);q;

      return state.leaderboard
    },

    async api_post_ic({ getters, state }, callback) {

      /** is Finished */
      if( (state.isValidProfiling || !state.data?.get?.profiling ) && state.isValidAnswer )
      {
        state.data.post.is_finished = 1

        window.dispatchEvent(new Event("ic:finished"));

        //remove temp
        Vue.prototype.$session.remove('temp_answers')
      }
      /** is Finished */

      var tempProfiling = state.data.post.profiling_answer;
      var dtPost = state.data.post

      /* Formatting Profiling */
      let formattedProfiling = []

      for( var i in tempProfiling )
      {
        formattedProfiling.push({
          input_name: i,
          data: tempProfiling[i]
        })
      }
      
      dtPost.profiling_answer = formattedProfiling;
      dtPost.visitor_id = state.data.visitorId;
      dtPost.user_id = state.data?.userLogin ? state.data?.userLogin?.data?.id : null;
      /* Formatting Profiling */
      console.log("debug2: ",dtPost);
      const data = await Promise.all([
        
        //POST NEWSHUB API
        getters.axios.post(
          "app/record-interactive/", qs.stringify(dtPost)
        )

      ]).catch(error => {
        
        Vue.toasted.show(error, {type:'error'}).goAway(1500);

        if(callback) return callback(null)

      });

      state.data.post.profiling_answer = tempProfiling;

      this.dispatch("scheduleCheck");

      if(callback) return callback(data[0].data)
    },

    async app_post_image({ getters, state }, params) {

      const dtPost = {
        base64: params.photo
      };

      const data = await Promise.all([
        
        //POST NEWSHUB API IMAGE
        getters.axios.post(
          "api/image&format=json&token="+state.token+'&'+(params.query||'resize=w:720'), qs.stringify(dtPost)
        )

      ]).catch(error => {
        
        Vue.toasted.show(error, {type:'error'}).goAway(1500);

        return null;
      });

      return data.length ? data[0].data : null;
    },

    async app_upload_image({ getters, state }, params) {

      const config = {
        onUploadProgress: function(progressEvent) {
          state.progressLoading = Math.round((progressEvent.loaded * 100) / progressEvent.total)
        }
      }

      const data = await Promise.all([
        
        //POST NEWSHUB API IMAGE
        getters.axios.post(
          "api/image&format=json&token="+state.token+'&', params, config
        )

      ]).catch(error => {
        
        Vue.toasted.show(error, {type:'error'}).goAway(1500);

        return null;
      });

      return data.length ? data[0].data : null;
    },

    async app_post_ic({ getters, state }, dtPost) {

      const data = await Promise.all([
        
        //POST NEWSHUB API CHECKLIST | TRIVIA
        getters.axios.post(
          "app/interactive-content/post&token="+state.token, qs.stringify(dtPost)
        )

      ]).catch(error => {
        
        Vue.toasted.show(error, {type:'error'}).goAway(1500);

        return null;
      });

      return data;
    },

    async api_post_ic_checklist({ state }, callback) {

      const dtPost = {
        action: 'checklist-score',
        answer: state.data.post.answer,
        tracking: state.data.post.tracking_id,
      };

      const data = await this.dispatch('app_post_ic', dtPost);

      //update result ID
      if( data[0] && data[0].data )
      {
        state.data.post.interactive_result_id = data[0].data.result.id;

        this.dispatch('api_post_ic');
      }

      if(callback) return callback(data[0].data)
    },

    async api_post_ic_tebak_skor({ state }, params) {

      const dtPost = {
        action: 'tebak-skor-check',
        interactive_content_id: state.data.get?.id,
        tracking: state.data.post.tracking_id,
      };

      if( params.score ) dtPost.score = params.score

      const data = await this.dispatch('app_post_ic', dtPost);

      if(params.callback) return params.callback(data[0].data)
    },

    async api_post_ic_url_link({ state }, params) {

      const dtPost = {
        action: 'ic-get-og',
        interactive_content_id: state.data.get?.id,
        url: params
      };

      const data = await this.dispatch('app_post_ic', dtPost);

      if(params.callback) return params.callback(data[0].data)
    },

    /**
     * 
     * @param [0] answer
     * @param [1] callback
     * @returns 
     */
    async api_post_ic_trivia({ state }, params) {

      const dtPost = {
        action: 'trivia-check',
        answer: params[0],
        tracking: state.data.post.tracking_id,
      };

      const data = await this.dispatch('app_post_ic', dtPost);

      if(params[1]) return params[1]({q:Object.keys(params[0]), data:data[0].data})
    },

    /**
     * 
     * @param [0] user_id
     * @param [1] callback
     * @returns 
     */
     async api_post_ic_last_answered({ state }, params) {

      const dtPost = {
        action: 'last_answered',
        interactive_content_id: state.data.get?.id,
        using_sso: state.data.get.using_sso,
        is_unique: state.data.get.is_unique,
        visitor_id: params.visitor_id||null,
        user_id: params.user_id||null,
      };
      console.log("debug: ",dtPost);
      const data = await this.dispatch('app_post_ic', dtPost);

      if(params.callback) return params.callback({data:data[0].data})
    },

    async api_post_ic_polling({ state }, callback) {

      if( state.data.post.answer && state.data.get.polling && state.data.post.answer[state.data.get.polling.id])
      {
          const dtPost = {
            interactive_content_id: state.data.get?.id,
            polling_id: state.data.post.answer[state.data.get.polling.id]
          };

          const data = await this.dispatch('app_post_ic', dtPost)

          if(callback) return callback(data[0].data)
      }
    },

    async api_post_ic_survey({ state }, callback) {

      if( state.data.post.answer && state.data.get.survey && state.data.post.answer[state.data.get.survey[0].id])
      {
          const dtPost = {
            interactive_content_id: state.data.get?.id,
            survey_id: state.data.post.answer[state.data.get.survey[0].id]
          };

          const data = await this.dispatch('app_post_ic', dtPost)

          if(callback) return callback(data[0].data)
      }
    },

    async api_post_ic_spinwin({ state }, callback) {

      if( state.data.get?.id )
      {
          const dtPost = {
            interactive_content_id: state.data.get?.id,
            visitor_id: state.data.visitorId,
            action: 'spin-win'
          };

          const data = await this.dispatch('app_post_ic', dtPost)

          if(callback) return callback(data[0].data)
      }
    },

    async api_ic_polling_check({ state }, callback) {

      if( state.data.get.polling )
      {
        const dtPost = {
          action: 'polling-check',
          interactive_content_id: state.data.get?.id
        };

        const data = await this.dispatch('app_post_ic', dtPost)

        if(callback) return callback(data[0].data)
      }
    },

    async api_ic_vote_reset({ state }, callback) {

      if( state.data.get.live_vote )
      {
        const dtPost = {
          action: 'live-vote-reset',
          interactive_content_id: state.data.get?.id
        };

        const data = await this.dispatch('app_post_ic', dtPost)

        if(callback) return callback(data[0].data)
      }
    },

    async api_post_ic_vote({ state }, callback) {

      if( state.data.post.answer && state.data.get.live_vote && state.data.post.answer[state.data.get.live_vote.id])
      {
          const dtPost = {
            action: 'live-vote-check',
            interactive_content_id: state.data.get?.id,
            vote_id: state.data.post.answer[state.data.get.live_vote.id]
          };

          if( state.data.userLogin ) dtPost.user = state.data.userLogin.data
          
          const data = await this.dispatch('app_post_ic', dtPost)

          if(callback) return callback(data[0].data)
      }
    },

    async api_join_ic_vote({ state }, callback) {

      if( state.data.userLogin && state.data.get.live_vote)
      {
          state.data.userLogin.data.tracking_id = state.data.post.tracking_id
          
          const dtPost = {
            action: 'live-vote-check',
            interactive_content_id: state.data.get?.id,
            user: state.data.userLogin.data
          };
                    
          const data = await this.dispatch('app_post_ic', dtPost)

          if(callback) return callback(data[0].data)
      }
    },

    async api_winner_ic_vote({ state }, callback) {

      if( state.data.get.live_vote)
      {
          const dtPost = {
            action: 'live-vote-winner',
            interactive_content_id: state.data.get?.id,
            max_win: state.data.get.live_vote.number_of_winner || 1,
            method: 'paling_banyak_vote'
          };

          const data = await this.dispatch('app_post_ic', dtPost)

          if(callback) return callback(data[0].data)
      }
    },

    async api_ic_vote_check({ state }, callback) {

      if( state.data.get.live_vote )
      {
        const dtPost = {
          action: 'live-vote-check',
          interactive_content_id: state.data.get?.id
        };

        const data = await this.dispatch('app_post_ic', dtPost)

        if(callback) return callback(data[0].data)
      }
    },

  },
  modules: {
  }
})